<template>
  <div class="container">
    <modals-container />
    <div class="row">
      <div class="col-lg-1"></div>
      <div class="col-lg-5 col-xs-12 p-2 pt-4">
        <a href="https://jovool.com">
          <img src="/images/Jovool_logo.png" />
        </a>
      </div>
      <div style="text-align: right" class="pt-4 col-lg-5 col-xs-12">
        <h1 class="color-primary"></h1>
      </div>
      <div class="col-lg-1"></div>
    </div>
    <div class="row">
      <div class="col-lg-1 col-xs-12"></div>
      <div class="col-lg-10 col-xs-12">
        <h1 class="color-primary mt-5">
          SHORTLIST NÃO ENCONTRADA, OU ACABOU O TEMPO LIMITE DE VISUALIZAÇÃO
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>